export const DAYS_PER_YEAR = 365
export const WEEKS_PER_YEAR = 52
export const MONTHS_PER_YEAR = 12
export const SEC_PER_MIN = 60
export const MIN_PER_HOUR = 60
export const HOURS_PER_DAY = 24
export const DAYS_PER_WEEK = 7
